import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils.js";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300",
  {
    variants: {
      variant: {
        default:
          "bg-slate-900 text-slate-50 dark:bg-slate-50 dark:text-slate-900",
        destructive:
          "bg-red-500 text-slate-50 dark:bg-red-900 dark:text-slate-50 ",
        outline:
          "border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950",
        "outline-command":
          "border border-slate-200 bg-white text-slate-900 dark:border-slate-800 dark:bg-slate-950",
        "outline-Kindred": "border border-slate-200 bg-[#303030]",
        secondary:
          "bg-slate-100 text-slate-900 80 dark:bg-slate-800 dark:text-slate-50",
        link: "text-slate-900 underline-offset-4 hover:underline dark:text-slate-50",
        kindred: "bg-blue-700 text-white",
        kindredForget: "bg-blue-300 text-black ",
        dropdownBtn: "bg-[#5296D5] text-black",
        addTechWeeklyBtn: "bg-[#5296D5] text-white",
        subBtn: "bg-[#316CF4] py-1 text-white",
        submit: "bg-[#408558] py-1 text-white",
        subButton: "bg-gray-600 py-1 px-1 text-white font-sm",
        playBtn: "bg-[#FF27CE] px-1 text-white",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
